import React from "react";
import PropTypes from "prop-types";
import ModalConfirm from "../modals/modal-confirm";
import FormManager from "./form-manager";

const ModalFormBase = ({
  data,
  disableFunc,
  header,
  render,
  onUnmount,
  onMount,
  onClose,
  width,
  submitLabel,
  disableEnterKeyOnForm,
  disableAutoComplete,
  children,
  ...props
}) => (
  <FormManager
    data={data}
    disableFunc={disableFunc}
    onSubmit={(state, setState) => {
      props.handleSubmit(state);
      onUnmount();
      onClose();
    }}
  >
    {({ isDisabled, state, setState, errors, handleSubmit }) => {
      const renderProp = typeof render === "function" ? render : children;
      return (
        <ModalConfirm
          {...props}
          closeModal={onClose}
          header={header}
          disableSave={isDisabled}
          saveLabel={submitLabel}
          onSubmit={handleSubmit}
        >
          <div data-testid="modal-confirm" className="et--modal-form">
            <form
              onSubmit={e => {
                e.preventDefault();
                handleSubmit(state, setState);
              }}
            >
              {renderProp({
                state,
                setState,
                errors,
              })}
            </form>
          </div>
        </ModalConfirm>
      );
    }}
  </FormManager>
);

ModalFormBase.defaultProps = {
  disableFunc: () => false,
  onUnmount: () => {},
  onClose: () => {},
  header: null,
  data: {},
};

ModalFormBase.propTypes = {
  /** give it a function that returns a) a boolean - will just disable the submit button
   * b) and object like {isDisabled: true, errors: {email: "Invalid", name: "this is a duplicate"}}
   *  this will disable the submit button and then pass this errors object into your render prop
   * use the errors object to display helpful messages to the user
   **/
  disableFunc: PropTypes.func,
  /** AKA initalState */
  data: PropTypes.object,
  header: PropTypes.string,
  /** params are `({setState, state})` */
  render: PropTypes.func,
  /** params: ({setState, state}) */
  handleSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  /** use a <form> 's onSubmit handler to catch the enter key */
  disableEnterKeyOnForm: PropTypes.bool,
  /** disable a <form> 's autocomplete feature or don't put a name on the input to disalbe individally */
  disableAutoComplete: PropTypes.bool,
};

ModalFormBase.displayName = "ModalFormBase";

export default ModalFormBase;
